import React, { useState, useEffect } from 'react';

import Alert from './Alert.jsx';


const FormHttpAlert = ({ res }) => {
  const [show, setShow] = useState(true);

  useEffect(() => setShow(true), [res]);

  return (
    <>
      {res.status === 'error' && show && (
        <Alert onClose={() => setShow(false)}>
          {res.payload}
        </Alert>
      )}
    </>
  );
};

export default FormHttpAlert;
